import { Map } from "maplibre-gl";
import { MutableRefObject } from "react";
import {
  SchoolID,
  SchoolType,
} from "../../../../editing_planning/data_requirements";
import { ScenarioKey } from "../../../../types/data/api";
import { MAP_LAYERS } from "../constants";
import { OPACITIES } from "./styleConstants";

export const filterBlocksByLevel = (
  map: MutableRefObject<Map>,
  level: SchoolType,
  scenario: ScenarioKey,
) => {
  map.current.setPaintProperty(MAP_LAYERS.planningBlocks, "fill-color", [
    "get",
    `${level.toLowerCase()}_${scenario}_color`,
  ]);
};

export const highlightSelectedSchool = (
  map: MutableRefObject<Map>,
  schoolID: SchoolID,
  level: SchoolType,
  scenario: ScenarioKey,
) => {
  map.current.setPaintProperty(MAP_LAYERS.planningBlocks, "fill-opacity", [
    "case",
    [
      "all",
      ["==", ["get", `${level.toLowerCase()}_${scenario}_id_`], schoolID],
      [
        "!=",
        ["get", `${level.toLowerCase()}_${scenario}_id_`],
        ["get", `${level.toLowerCase()}_0_id_`],
      ],
    ],
    1,
    [
      "all",
      ["==", ["get", `${level.toLowerCase()}_${scenario}_id_`], schoolID],
      [
        "==",
        ["get", `${level.toLowerCase()}_${scenario}_id_`],
        ["get", `${level.toLowerCase()}_0_id_`],
      ],
    ],
    OPACITIES.HIGHLIGHTED,
    OPACITIES.FADED,
  ]);
};

export const resetBlockOpacities = (map: MutableRefObject<Map>) => {
  map.current.setPaintProperty(
    MAP_LAYERS.planningBlocks,
    "fill-opacity",
    OPACITIES.DEFAULT,
  );
};
